var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('HomeHero'),_c('HomeSchedule'),_c('HomeMission'),_c('HomeMinistries'),_c('HomeGallery'),_c('HomeBlog'),_c('HomeVisit'),_c('HomeImpact'),_c('CookieNotice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }